module.exports = __webpack_public_path__ + "static/media/halloweenSD.8250a436.mp4";